import { Component, Input } from '@angular/core';
import { ColorEnums } from '../../common/colors-enums';
import { CommonModule } from '@angular/common';
import { SeverityClassEnum } from '../../common/severity-class.enum';

@Component({
    selector: 'app-header-summary-card',
    templateUrl: 'header-summary-card.component.html',
    styleUrls: ['./header-summary-card.component.scss'],
    imports: [CommonModule]
})
export class HeaderSummaryCardComponent {
  @Input() text: string = ''; // The body text
  @Input() value: number | string = 0; // The value displayed
  @Input() id: number = ColorEnums.drafted; // The ID to determine the color, default is "drafted"
  @Input() severityClass: keyof typeof SeverityClassEnum | SeverityClassEnum =
    'info';

  // Maps the id to the corresponding CSS class based on the enum
  getColorClass(): string {
    const colorClass = ColorEnums[this.id]; // Dynamically retrieve the enum key
    return colorClass ?? ColorEnums[ColorEnums.drafted];
  }
}
